import { XRay } from './XRay';
export default XRay;